import firebase from "firebase/compat/app"
// import storage from "firebase/compat/storage"

let app = null;
if (!firebase.apps.length) {
    console.log("FIREBASE NOT YET INIT");
    app = firebase.initializeApp ({
        apiKey: process.env.NEXT_PUBLIC_API_KEY, 
        authDomain: process.env.NEXT_PUBLIC_AUTH_DOMAIN, 
        // databaseURL: process.env.NEXT_PUBLIC_DATABASE_URL, 
        projectId: process.env.NEXT_PUBLIC_PROJECT_ID, 
        storageBucket: process.env.NEXT_PUBLIC_STORAGE_BUCKET, 
        messagingSenderId: process.env.NEXT_PUBLIC_MESSAGING_SENDER_ID, 
        appId: process.env.NEXT_PUBLIC_APP_ID//, 
        // measurementId: process.env.NEXT_PUBLIC_MEASUREMENT_ID
    }) 
} else {
    console.log("FIREBASE ALREADY INIT");
    app = firebase.app(); // if already initialized, use that one
}

export default app;